<section class="page__header">
  <custom-app-bar
    [hasCloseButton]="true"
    [title]="'add_to_list.title' | translate"
    [hasSafeArea]="false"
  ></custom-app-bar>
</section>

<section class="page__content">
  <button
    *ngIf="isMobile$ | async"
    class="creat-new-list-button--mobile"
    customButton
    size="large"
    appearance="text"
    (click)="createNewList()"
  >
    <svg-icon src="./assets/icons/plus-circle.svg"></svg-icon>
    <div>
      {{ "add_to_list.create_new_list" | translate }}
    </div>
  </button>
  <ng-container *ngIf="{listOfList: (listOfList$ | async) } as vm">
    <ul class="list-of-list" *ngIf="!(isGetAllListLoading$ | async); else skeleton">
      <li
              class="list"
              *ngFor="let list of vm.listOfList"
              (click)="addToList(list.id)"
      >
        <img
                class="list__image"
                *ngIf="list.products.length"
                [src]="list.products[0].image"
                [alt]="list.name + ' image'"
        />
        <div
                class="list__image list__image--placeholder"
                *ngIf="!list.products.length"
        >
          <svg-icon
                  class="app-bar__icon"
                  src="./assets/icons/heart.svg"
          ></svg-icon>
        </div>
        <div class="list__info">
          <p class="list__name">{{ list.name }}</p>
          <p class="list__products-quantity">
            {{
            "add_to_list.n_products"
                    | translate: { quantity: list.products.length }
            }}
          </p>
        </div>
      </li>
    </ul>
  </ng-container>

  <ng-template #skeleton>
    <ul class="list-of-list">
        <ngx-skeleton-loader
                *ngFor="let i of [0,0,0]"
                class="ep-skeleton-loader"
                [theme]="{
            'height': '65px',
            'width': '100%',
            'background-color': 'var(--skeleton-background-color)',
            'foregroundColor': 'red',
            'margin-bottom': '5px',
            'border-radius': '0'
        }"
        ></ngx-skeleton-loader>
    </ul>
  </ng-template>
</section>

<section *ngIf="isDesktop$ | async" class="page__footer">
  <button customButton expand="full" size="large" (click)="createNewList()">
    <svg-icon src="./assets/icons/plus-circle.svg"></svg-icon>
    <span>
      {{ "add_to_list.create_new_list" | translate }}
    </span>
  </button>
</section>
